import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import {
  CreateCatalogModal,
  EditCatalogModal,
  CatalogListFilters,
} from "@modules/catalogs/components";

import { useCatalogList } from "./controller";
import { useCatalogListColumns } from "./columns";

export const CatalogList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    createCatalogModalRef,
    editCatalogModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useCatalogList();

  const columns = useCatalogListColumns(
    refetch,
    translate,
    editCatalogModalRef
  );

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <CatalogListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="agreements.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createCatalogModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateCatalogModal
        onComplete={() => {
          refetch();
        }}
        modalRef={createCatalogModalRef}
      />
      <EditCatalogModal
        onComplete={() => {
          refetch();
        }}
        modalRef={editCatalogModalRef}
      />
    </List>
  );
});
